import { renderGroupFilterByColumn } from '@/components/feedbacks-table/feedbacks-table-columns.filters.groups';
import { renderMetaFilterByColumn } from '@/components/feedbacks-table/feedbacks-table-columns.filters.meta';
import { renderTextFilterByColumn } from '@/components/feedbacks-table/feedbacks-table-columns.filters.text';
import {
    FeedbacksTableData,
    FeedbacksTableFiltersApi,
} from '@/components/feedbacks-table/feedbacks-table-columns.types';
import { TableFilterCheckboxHeaderCell } from '@/components/table-selection/TableSelectionHeaderControls';
import { TableColumn } from '@/ui/Table';
import clsx from 'clsx';

export const renderFeedbacksTableFilterByColumn = (
    columnKey: keyof FeedbacksTableData,
    filters: FeedbacksTableFiltersApi,
) => {
    return (
        renderMetaFilterByColumn(columnKey, filters) ||
        renderTextFilterByColumn(columnKey, filters) ||
        renderGroupFilterByColumn(columnKey, filters)
    );
};

type BuildFeedbacksTableHeaderSecondaryRowArgs = {
    columns: TableColumn<FeedbacksTableData>[];
    pickedReviews: string[];
    filters: FeedbacksTableFiltersApi;
    isHeaderChecked: boolean;
    isSelectionSyncing: boolean;
    onHeaderCheckboxChange: (checked: boolean) => void;
};

export const buildFeedbacksTableHeaderSecondaryRow = ({
    columns,
    pickedReviews,
    filters,
    isHeaderChecked,
    isSelectionSyncing,
    onHeaderCheckboxChange,
}: BuildFeedbacksTableHeaderSecondaryRowArgs) => (
    <tr className="h-10 border-b border-slate-200 bg-gray-50">
        {pickedReviews !== undefined && (
            <TableFilterCheckboxHeaderCell
                key="header-filter-checkbox"
                isChecked={isHeaderChecked}
                isSyncing={isSelectionSyncing}
                onChange={onHeaderCheckboxChange}
            />
        )}
        {columns.map((column) => (
            <th
                key={`${column.alias}-filter`}
                className={clsx('h-10 px-1 py-0 text-start align-middle', column.className)}
            >
                {renderFeedbacksTableFilterByColumn(column.key, filters)}
            </th>
        ))}
    </tr>
);
